import Conversion from "./Conversion";

export default class JobSettings {
    conversion = {};
    layout =  {
        sidebarLeftOpen: false
    }

    constructor() {
        this.conversion = new Conversion();
    }
}